import { crudActions, crudMutations, crudGetters } from "@/utils/store";
import isEmpty from "lodash/isEmpty"

const BASE_URL = 'admin/property_templates/'
const BASE_URL_V2 = process.env.BASE_URL_V2

export const state = () => ({
  objects: [],
  total: 0,
  consts: {},
})

export const mutations = {
  ...crudMutations,
  setConsts(state, payload) {
    state.consts = payload
  },
}

const cleanUpPayload = (payload) => {
  const result = { ...payload };
  delete result['id']
  delete result['idx']
  return result
}

export const actions = {
  ...crudActions(BASE_URL),
  async uploadPictoImage(state, { object_id, field, file }) {
    const formData = new FormData();
    formData.append('file', file);

    return this.$axios.$post(`/admin/property_templates_files/${object_id}/${field}/?content_type=${encodeURIComponent(file.type)}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  async getConsts({ state, commit }) {
    if (isEmpty(state.consts)) {
      commit('setConsts', await this.$axios.$get(`${BASE_URL_V2}/constants/`))
      return state.consts
    } else {
      return state.consts
    }
  },
  async refreshConsts({ state, commit }) {
    commit('setConsts', await this.$axios.$get(`${BASE_URL_V2}/constants/`))
    return state.consts
  },
  async addListItem(state, { template_id, item }) {
    return this.$axios.post(`/admin/properties/templates/${template_id}/add_list_item/`, {
      value: item
    })
  },
}

export const getters = {
  ...crudGetters,
  siTypes: (state) => {
    return state?.consts?.si ?? []
  },
}
